import { http } from 'vue'

export default {
  // load client from the API server
  loadClient (context, params = {}) {
    const withParam = params.with ? '&with=' + params.with : ''
    const companyParam = params.companyId ? '&company_id=' + params.companyId : ''
    return http.get('clients' + '?user_id=' + params.userId + withParam + companyParam)
  },
  // create client at the API server
  postClient (context, params = {}) {
    return http.post('clients', params.data)
  },
  // edit client at the API server
  putClient (context, params = {}) {
    return http.put('clients/' + params.id, params.data)
  },
  // save client at the store
  saveClient (context, payload) {
    context.commit('SAVE_CLIENT', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/actions.js